var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "node-name" }, [_c('el-input', _vm._b({ ref: "input", attrs: { "type": "input", "value": _vm.formValue[_vm.config.prop] }, on: { "input": _vm.handleInput } }, 'el-input', _vm.config.params, false))], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };